import SortDirection, { type SortDirectionType } from '@rio-cloud/rio-uikit/SortDirection';
import { sortByProperty } from '@rio-cloud/rio-uikit/SortUtils';
import chunk from 'lodash/fp/chunk';
import flatten from 'lodash/fp/flatten';
import flow from 'lodash/fp/flow';
import slice from 'lodash/fp/slice';
import type { IntlShape } from 'react-intl';

import type { TransformedData } from '../../services/types';

export const DATA_ATTRIBUTE = 'data-key';

export const getSortDir = (sortBy: string, previousSortBy: string, sortDir: string) => {
    if (sortBy === previousSortBy) {
        return sortDir === SortDirection.ASCENDING ? SortDirection.DESCENDING : SortDirection.ASCENDING;
    }
    return SortDirection.ASCENDING;
};

export const sortItems = <T>(items: T[], sortBy: keyof T, sortDir: SortDirectionType) =>
    sortBy ? sortByProperty(items, sortBy, sortDir) : items;

export const isMatchingValue = (value = '', match = '') => value.toString().toLowerCase().includes(match.toLowerCase());

export const chunkContent = (content: TransformedData[], chunks: number, chunkSize: number) => {
    const chunkedResult = chunk(chunkSize, content);
    const chunkedContent = flow(slice(0, chunks), flatten)(chunkedResult) as unknown as TransformedData[];

    const hasMoreChunks = chunkedResult.length > chunks;

    return {
        chunkedContent,
        hasMoreChunks,
    };
};

export const getTranslatedLabels = (labels: Record<string, string>, intl: IntlShape) => {
    const translatedLabels = { ...labels };
    Object.keys(labels).forEach(key => {
        translatedLabels[key] = intl.formatMessage({ id: labels[key] }) || '';
    });
    return translatedLabels;
};
